
















































































































































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
import { mapasService } from "@/service/MapasService";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import LocalidadeModel from "@/models/cadastros/assistencia/geolocalizacao/LocalidadeModel";
import { estadosList, RIO_GRANDE_DO_SUL } from "@/models/cadastros/assistencia/Estados";
import { ValidationObserver } from "vee-validate";
import EnderecoModel from "@/models/EnderecoModel";

//@ts-ignore
import _ from 'lodash';

@Component
export default class LocalizadorEndereco extends Vue {
  estados = estadosList;
  tiposEnderecos = tiposEndereco;

  urlView = '';

  $refs!: {
    enderecoObserver: InstanceType<typeof ValidationObserver>;
  };

  cepDigitado = false;
  loadingEndereco = false;
  pesquisarAlteracao = false;

  endereco: EnderecoModel = {
    cep: "",
    logradouro: "",
    numero: undefined,
    complemento: "",
    bairro: "",
    cidade: "",
    estado: undefined,
  };

  @Prop({ type: String, default: "" })
  title!: string;

  @Prop({ type: Boolean, default: false })
  url!: Boolean;

  @Prop({ type: Boolean, default: false })
  validarPatins!: Boolean;

  @Prop({ type: Boolean, default: false })
  tipoEnd!: Boolean;

  @Prop({ type: Boolean, default: false })
  clienteAdm!: Boolean;

  @PropSync("endereco")
  enderecoSelecionado!: LocalidadeModel;

  @Prop({ type: String, default: "" })
  origem!: string;

  localidade = "";

  exbirEnderecos = false;
  enderecosLocalizados = [] as LocalidadeModel[];

  get informarEnderecoManual() {
    return (
      this.enderecoSelecionado &&
      !this.enderecoSelecionado.informarEnderecoManual
    );
  }

  linkError = false;
  linkColor() {
    return this.linkError ? 'link-error' : 'link-success';
  }

  selecionouEndereco = false;

  selecionarEndereco() {
    this.selecionouEndereco = true;
  }

  // Utilizado para o debounce manual
  timerLocalidade: any;
  loading = false;

  @Watch("endereco.cep")
  obterEnderecoPorCep(val: string) {
    if (!this.clienteAdm) {
      if (this.pesquisarAlteracao) {
        if (val && val.replace(/\D/g, "").length == 8) {
          this.pesquisarEnderecoPorCep(val);
        }
      } else {
        this.pesquisarAlteracao = true;
      }
    }  
    this.clienteAdm = false;
  }

  @Watch("endereco.latitude")
  @Watch("endereco.longitude") // https://maps.google.com/?q=-23.592684,-46.542656 | https://maps.google.com/?q=-24.0735311,-49.1724602
  montarUrl() {
    this.linkError = false;

    if (this.enderecoSelecionado.latitude == undefined || this.enderecoSelecionado.longitude == undefined ||
       !this.enderecoSelecionado.latitude || !this.enderecoSelecionado.longitude) {
      this.urlView = '';
      return;
    }
    this.enderecoSelecionado.cep = "";
    this.cepDigitado = false;
    let novaUrl = (`https://maps.google.com/?q=${this.enderecoSelecionado.latitude},${this.enderecoSelecionado.longitude}`)

    this.urlView = novaUrl;
  }

  pesquisarEnderecoPorCep(val: string) {
    this.cepDigitado = false;
    if (val && val.replace(/\D/g, "").length == 8) {
      this.loadingEndereco = true;
      this.cepDigitado = true;
      mapasService
        .obterEnderecoPorCep(val.replace(/\D/g, ""))
        .then((res) => {
          // console.log(res);
          const endereco = new LocalidadeModel();
          
          endereco.cep = this.enderecoSelecionado?.cep;

          endereco.logradouro = res.logradouro;
          endereco.bairro = res.bairro;
          endereco.cidade = res.cidade;
          endereco.informarEnderecoManual = false;
          if (res.estado) {
            endereco.estado = estadosList.find(
              (e) => e.sigla == (res.estado?.sigla || "")
            );
          } else {
            endereco.estado = undefined;
          }
          this.enderecoSelecionado = endereco;
        })
        .finally(() => {
          this.loadingEndereco = false;
        });
    }
  }

  @Watch("enderecoSelecionado")
  @Watch("enderecoSelecionado.logradouro")
  @Watch("enderecoSelecionado.numero")
  @Watch("enderecoSelecionado.bairro")
  buscarEnderecos() {
    const endereco = this.enderecoSelecionado;
    if (endereco) {
      const val = `${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}, ${endereco.cidade}, ${endereco.estado?.nome}`;
      // val = (val || "").trim();

//     // se o campo tem menos que 5 caracteres não faz a busca
//     if (val.length < 4) return;

//     this.loading = true;

//     // Debounce manual - LODASH não funcionou
//     clearTimeout(this.timerLocalidade);

//     this.timerLocalidade = setTimeout(() => {
//       mapasService
//         .obterEnderecos(val)
//         .then((res) => {
//           if (this.selecionouEndereco && res.length == 1) {
//             this.enderecosLocalizados = res;
//             this.enderecoSelecionado = res[0];
//           } else {
//             res.push({
//               logradouro: "",
//               numero: "",
//               complemento: "",
//               bairro: "",
//               cidade: "",
//               estado: RIO_GRANDE_DO_SUL,
//               enderecoCompleto: "O endereço desejado não está na lista",
//               informarEnderecoManual: true,
//             });
//             this.enderecosLocalizados = res;
//           }
//           this.selecionouEndereco = false;

      // if (val == "") {
      //   this.enderecosLocalizados = [];
      //   return;
      // }

      // se o campo tem menos que 5 caracteres não faz a busca
      if (val.length < 4) return;

      this.loading = true;
      
      // Debounce manual - LODASH não funcionou
      clearTimeout(this.timerLocalidade);
      
      this.timerLocalidade = setTimeout(() => {
        mapasService.obterEnderecos(val)
        .then((res) => {
            const endereco = this.enderecoSelecionado as LocalidadeModel;
            if (res.length > 1) {
              res.forEach((item) => {
                  if (item.cep) {
                    if (item.cep == this.enderecoSelecionado.cep) {
                      endereco.geoPosicao = item.geoPosicao;
                      endereco.informarEnderecoManual = false;
                      this.enderecoSelecionado = endereco;
                    }
                  }  
              });
            } else {
              if ((!endereco.geoPosicao || (endereco.geoPosicao.latitude != res[0].geoPosicao?.latitude || endereco.geoPosicao.longitude != res[0].geoPosicao?.longitude)) && res.length > 0) {
                endereco.geoPosicao = res[0].geoPosicao;
              }
              endereco.informarEnderecoManual = false;
              this.enderecoSelecionado = endereco;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      }, 300);
    }
  }
}
